<script lang="ts" setup>
</script>

<template>
  <svg
    width="66"
    height="66"
    viewBox="0 0 66 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3926 57.8V36.1H5.09814V57.8M29.8833 57.8V29.9H20.5888V57.8M45.374 57.6233V36.1H36.0796V57.8M60.8647 57.4683V23.7H51.5703V57.6233M2 64H64M5.09814 29.9L23.687 11.3L39.1777 26.8L63.9628 2M63.9628 2H54.6684M63.9628 2V11.3"
      stroke="#5061FA"
      stroke-width="3.09134"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style lang="scss" scoped>
</style>
